<template>
	<div>
		<ul v-if="transcription.length" class="flex flex-col gap-10 w-full p-4">
			<li v-for="t in transcription" :key="t.startTime" class="flex gap-10">
				<span class="text-gray-400 text-sm">
					{{ formatTimestamp(t.startTime) }}
				</span>

				<div class="flex flex-col">
					<span class="font-bold">{{ t.speaker }}</span>
					<span>
						<span v-if="t.sentence">
							{{ t.sentence }}
						</span>
						<span v-if="t.partialSentence" class="text-gray-400">
							{{ t.partialSentence }}
						</span>
					</span>
				</div>
			</li>
		</ul>
		<span
			v-else-if="
				!['errored', 'processed'].includes(currentMeeting?.status ?? '') &&
				currentMeeting?.type === 'upload'
			"
			class="text-gray-500"
		>
			Transcript wordt gemaakt...
		</span>
	</div>
</template>

<script setup lang="ts">
import { recognitionResultsToSentences } from "@/composables/useSpeechmaticsTranscriber";
import { useQuery } from "@/composables/useZero";
import { formatTimestamp } from "@/helpers/uiHelpers";
import { conversationKey } from "@/keys";
import { useRecorderStore } from "@/store/useRecorderStore";
import { queries } from "@loanlink-nl/zero";
import type { RecognitionResult } from "@speechmatics/real-time-client";
import { computed, inject } from "vue";

type TranscriptionResults = { results: RecognitionResult[] } | undefined;

const currentMeeting = inject(conversationKey);
const recorder = useRecorderStore();

const { data: conversationDetail } = useQuery(() =>
	queries.conversationDetails.byConversationId({
		conversationId: currentMeeting?.value?.id ?? "",
	}),
);

const transcription = computed(() => {
	if (recorder.recording && recorder.meetingId === currentMeeting?.value?.id) {
		// Use live transcription from recorder store
		return recorder.sentences;
	}

	const { results } =
		(conversationDetail.value?.transcriptionResult as TranscriptionResults) ??
		{};

	return recognitionResultsToSentences(results ?? []);
});
</script>
